export const communicationServiceEndpointURL = process.env.REACT_APP_AZURE_COMM_SERVICE || '';
